import store from "@/store";


function checkUserAccess(action) {
  let userAccess = store.state.appConfig.userAccess;
  return userAccess.includes(action);
}

function toPersianCurrency(value, symbol, decimals, options) {

  let separator;
  let digitsRE = /(\d{3})(?=\d)/g;
  let sign = value < 0 ? "-" : "";
  options = options || {};
  value = parseFloat(value);
  if (!isFinite(value) || (!value && value !== 0)) return "";
  symbol = symbol != null ? sign + " " + symbol : sign + " " + "تومان";
  decimals = decimals != null ? decimals : 2;
  separator = options.separator != null ? options.separator : ",";
  let stringified = Math.abs(value).toFixed(decimals);
  stringified = options.decimalSeparator
    ? stringified.replace(".", options.decimalSeparator)
    : stringified;
  let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  let i = _int.length % 3;
  let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? separator : "") : "";
  let _float = decimals ? stringified.slice(-1 - decimals) : "";
  symbol =
    "‫‫" +
    head +
    _int.slice(i).replace(digitsRE, "$1" + separator) +
    _float +
    symbol;
  return symbol;
}

const mixins = {
  /*data(){
        return {
          loggined:false,
          userData:null
        }
  },*/
  mounted(){
    console.log("this is from mixin");
      //this.authcheck();
  },
    methods:{
      authcheck(){
        console.log("checking auth");
        if(store.state.login.loginTempToken){
          this.getProfile();
          this.loggined = true;
          console.log("loggined!");
        }else{
          this.loggined = false;
          console.log("not loggined!");
        }
      },
      async getProfile() {
        let fd = new FormData();
        fd.append("token", store.state.login.loginTempToken);
        const response = await this.$ApiServiceLayer.post("get_profile", fd);

        if(response.status_code === 200) {
          this.userData = response;
        }

        if(response.status_code === 500){
          window.localStorage.removeItem("kishoto-store");
          window.localStorage.removeItem("token");

          setTimeout(()=>{
            window.open("/","_self");
          },1000);
        }
      }

      /*toPersianCurrency: function (value, symbol, decimals, options) {

  let separator;
  let digitsRE = /(\d{3})(?=\d)/g;
  let sign = value < 0 ? "-" : "";
  options = options || {};
  value = parseFloat(value);
  if (!isFinite(value) || (!value && value !== 0)) return "";
  symbol = symbol != null ? sign + " " + symbol : sign + " " + "تومان";
  decimals = decimals != null ? decimals : 2;
  separator = options.separator != null ? options.separator : ",";
  let stringified = Math.abs(value).toFixed(decimals);
  stringified = options.decimalSeparator
      ? stringified.replace(".", options.decimalSeparator)
      : stringified;
  let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  let i = _int.length % 3;
  let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? separator : "") : "";
  let _float = decimals ? stringified.slice(-1 - decimals) : "";
  symbol =
      "‫‫" +
      head +
      _int.slice(i).replace(digitsRE, "$1" + separator) +
      _float +
      symbol;
  return symbol;
}*/
      //checkUserAccess,
    }
};

export default mixins;
